import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  usePlanList,
  init,
  fetch,
};

let g_planList: any;

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function _addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function _removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function _subscribe(callback: any) {
  _addChangeListener(callback);
  return () => {
    _removeChangeListener(callback);
  };
}
function init(done) {
  done?.();
}
function _getPlanList() {
  return g_planList;
}
export function usePlanList() {
  return React.useSyncExternalStore(_subscribe, _getPlanList);
}
function fetch(done?: (err: any) => void) {
  const opts = { url: `/admin/1/plan` };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('OrgStore.fetch: err:', err, body);
    } else {
      if (!util.deepEqual(g_planList, body.plan_list)) {
        g_planList = body.plan_list;
        _emit('update');
      }
    }
    done?.(err);
  });
}
